import styled from "@emotion/styled"
import React from "react"
import CapitariaLogoBlack from "../ui/images/capitaria-logo-black"


const WrapperMision = styled.div`
  width: 100%;
  min-height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`

const TextMisionContainer = styled.div`
  max-width: 775px;
`

const TextMision = styled.p`
  color: #525050;
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 31.2px;
  letter-spacing: 2.52px;
  margin-left: 10px;
  margin-right: 10px;
  @media (max-width:580px) {
    font-size: 17px;
  }
`


const Mision = () => (
  <WrapperMision>
    <CapitariaLogoBlack />
    <TextMisionContainer>
      <TextMision>
        Tenemos la misión de empoderar a las
        personas para que tomen el control de sus
        inversiones. Te entregamos educación
        constante, información oportuna y una
        plataforma intuitiva, para que con un clic
        puedas invertir en los mercados del mundo.
      </TextMision>
    </TextMisionContainer>
  </WrapperMision>
)

export default Mision
